import { render, staticRenderFns } from "./Packaging.vue?vue&type=template&id=3d8b90f1&scoped=true&"
import script from "./Packaging.vue?vue&type=script&lang=js&"
export * from "./Packaging.vue?vue&type=script&lang=js&"
import style0 from "./Packaging.vue?vue&type=style&index=0&id=3d8b90f1&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d8b90f1",
  null
  
)

export default component.exports